import $ from 'jquery';
import { BREAKPOINTS } from "./breakpoints";
import debounce from 'lodash.debounce';
import lozad from 'lozad';
import SmoothScroll from 'smooth-scroll';
import Sticky from './sticky';
import ScrollOut from 'scroll-out';

// サイト全体で使うもの、特定のページに限定されないもの
export default class Common {
    constructor() {
        this.$window = $(window);
        this.$body = $('body');
        this.$globalNav = $('.js-globalNav');
        this.globalNavHeight = this.$globalNav.outerHeight();//borderを含めナビゲーションのheightを取得
        this.windowWidth = window.innerWidth; // ブラウザのスクロールバーも含めて横幅を取得
        this.windowHeight = window.innerHeight;
        this.beforeWidth = this.windowWidth;
        this.scrollCount = null;

        // loazed.js
        // Intersection ObserverによるLazyLoad
        // ref:https://qiita.com/yukagil/items/369a9972fd45223677fd
        // ref:https://www.rectus.co.jp/archives/358#IE_Polyfill
        const observer = lozad();
        // const observer = lozad('.lozad', {
        //     load: function(el) {
        //         // Custom implementation to load an element
        //         el.src = el.getAttribute('data-lozad-src');
        //     }
        // });
        observer.observe();

        // SmoothScroll発火
        // ページ内でのアンカーリンクに対して機能する
        const scroll = new SmoothScroll('[data-smooth-scroll]', {
            header: '[data-scroll-header]'
        });

        // sticky state
        Sticky();

        // scrollout
        this.scrollOut();

        this.setEventHandlers();
        this.toggleHamburgerMenu();

        this.imageModalFunction();

        this.setContentMinHeight();

        // TODO: 別ファイルにする
        this.singlePage();

        $('[data-toggle-target]').on('click', (e) => {
            const target = $(e.currentTarget).data('toggle-target');
            $(`[data-toggle-id="${target}"]`).slideToggle('fast');
            $(e.currentTarget).toggleClass('is-show');
        });

        // if ($('.js-property-contact-form-wrapper').find('.mw_wp_form_complete').length || $('.js-property-contact-form-wrapper').find('.error').length) {
        //     $('.js-hide-target').hide();
        //     $('#contact-modal').modal({
        //         fadeDuration: 250,
        //         fadeDelay: 0.80
        //     });
        // }

        // if ($('.js-general-contact-form-wrapper').find('.mw_wp_form_complete').length) {
        //     const $clone = $('.mw_wp_form_complete').clone();
        //     $('.js-form-complete-modal-content').append($clone);
        //     $('#form-complete-modal').modal({
        //         fadeDuration: 250,
        //         fadeDelay: 0.80
        //     });
        // }

        if (this.windowWidth < BREAKPOINTS.small.px) {
            // console.log("smaller than SMALL!");
        } else if (this.windowWidth < BREAKPOINTS.MEDIUM) {
            // console.log("smaller than MEDIUM!");
        } else if (this.windowWidth < BREAKPOINTS.LARGE) {
            this.switchImgResponsive(this.windowWidth);
            this.switchBgImgResponsive(this.windowWidth);
        } else {
            this.toggleGlobalNavigation();
            this.switchImgResponsive(this.windowWidth);
            this.switchBgImgResponsive(this.windowWidth);
        }
        this.$window.on('resize', debounce(() => {
            this.windowWidth = window.innerWidth;
            this.windowHeight = window.innerHeight;
            if (this.windowWidth < BREAKPOINTS.small.px) {
                // iOS/Androidではスクロールした時にurlバーが表示・非表示される度にresizeイベントが発火するため
                // resize発火後に縦横が変わったときだけresizeとみなして処理する（横幅に変化がなければキャンセル）
                if (this.beforeWidth == this.windowWidth) {
                    return;
                } else {//ランドスケープになったときの処理
                    this.switchImgResponsive(this.windowWidth);
                    this.switchBgImgResponsive(this.windowWidth);
                }
                // 横幅を更新
                this.beforeWidth = this.windowWidth;
            } else if (this.windowWidth < BREAKPOINTS.MEDIUM) {
                if (this.beforeWidth == this.windowWidth) {
                    return;
                } else {
                    this.switchImgResponsive(this.windowWidth);
                    this.switchBgImgResponsive(this.windowWidth);
                }
                this.beforeWidth = this.windowWidth;
            } else if (this.windowWidth < BREAKPOINTS.LARGE) {
                if (this.beforeWidth == this.windowWidth) {
                    return;
                } else {
                    this.switchImgResponsive(this.windowWidth);
                    this.switchBgImgResponsive(this.windowWidth);
                }
                this.beforeWidth = this.windowWidth;
            } else {
                // BREAKPOINTS.LARGE以上のサイズでは横幅の変化でも処理をする
                this.switchImgResponsive(this.windowWidth);
                this.switchBgImgResponsive(this.windowWidth);
                this.beforeWidth = this.windowWidth;
            }
        }, 500));
    }

    setEventHandlers() {
        $('.js-stopPropagation').on('click', (e) => {
            this.stopPropagation(e);
        });
        $('.js-nestedContentToggleTrigger').on('click', (e) => {
            this.toggleNestedContent(e);
        });
        // $('.js-nestedContentToggleTriggerLink').on('click', (e) => {
        //     if (this.windowWidth < BREAKPOINTS.LARGE) {
        //         e.preventDefault();
        //     }
        // });
    }

    //ハンバーガーメニューの開閉
    toggleHamburgerMenu() {
        let scrollPosition = null;
        $('.js-globalNavTriggerBtn').on('click', (e) => {
            const $body = $('body');
            const navStatus = $('body').attr('data-nav-status');
            // $('.js-globalNavToggleContent').slideToggle();
            $('.js-globalNavToggleContent').toggleClass('is-open');
            $(e.currentTarget).toggleClass('is-open');
            if (!navStatus || navStatus == 'is-close') {
                scrollPosition = this.$window.scrollTop();
                $body.attr('data-nav-status', 'is-open');
                $body.css('top', -scrollPosition);
                $('.js-nav-mask').css('top', scrollPosition);
            } else {
                $body.attr('data-nav-status', 'is-close');
                $body.removeAttr('style');
                window.scrollTo(0, scrollPosition);
            }
        });
        $('.js-nav-mask').on('click', function () {
            $('body').attr('data-nav-status', 'is-close').removeAttr('style');
            window.scrollTo(0, scrollPosition);
            $('.js-globalNavToggleContent, .js-globalNavTriggerBtn').removeClass('is-open');
        });
    }

    //スクロールに応じたglobal navigationの表示制御
    toggleGlobalNavigation() {
        let startScrollPos = 0;
        this.$window.on('scroll', debounce(() => {
            this.scrollCount = this.$window.scrollTop();
            if (this.scrollCount > startScrollPos) {
                //下方向のスクロール時
                if (this.scrollCount > this.globalNavHeight) {
                    this.$globalNav.removeClass('is-show').addClass('is-hide');
                    this.$globalNav.on('transitionend', () => {
                        this.$globalNav.addClass('is-fixed');
                    });
                } else {
                    this.$globalNav.removeClass('is-hide is-show');
                }
            } else {
                //上方向のスクロール時
                this.$globalNav.removeClass('is-hide').addClass('is-show');
                if (this.scrollCount < this.globalNavHeight) {
                    this.$globalNav.removeClass('is-hide is-show');
                    this.$globalNav.on('transitionend', () => {
                        this.$globalNav.removeClass('is-fixed');
                    });
                }
            }
            startScrollPos = this.$window.scrollTop();
        }, 200));
    }

    //ページ遷移時にアンカーリンク指定があった場合にfixedヘッダー分の位置を調整
    fixAnkerLinkScrollPosition() {
        //URLのハッシュ値を取得
        const urlHash = location.hash;
        //ハッシュ値があればページ内スクロール
        if (urlHash) {
            const targetPosition = $(urlHash).offset().top;
            $(window).scrollTop(targetPosition - this.globalNavHeight);
        }
    }

    //イベント伝播ストップIE対応
    stopPropagation(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
        } else {
            e.cancelBubble = true;
        }
    }

    //階層構造になっているメニューの開閉
    toggleNestedContent(e) {
        // 今のところpcでは無効
        if (this.windowWidth < BREAKPOINTS.LARGE) {
            const $toggleTriggers = $(e.currentTarget).closest('.js-nestedContentWrapper').find('.js-nestedContentToggleTrigger');
            if (!$(e.currentTarget).hasClass('is-open')) {
                // 表示中の兄弟要素を閉じる
                $toggleTriggers.removeClass('is-open').next('.js-nestedContent').slideUp();
            }
            $(e.currentTarget).next('.js-nestedContent').slideToggle();
            $(e.currentTarget).toggleClass('is-open');
        }
    }

    // モバイルファーストで設定した画像をdesktopサイズにswitchする
    // prPage.jsのswitchEyecatchImgSrc()はlandscape画像をデフォルトとして、オプショナルでスマホ用画像の設定ができるようにしている
    switchImgResponsive(windowWidth) {
        $('.js-switch-image-responsive').each((i, el) => {
            const smImgSrc = $(el).data('switch-image-sm');
            const lgImgSrc = $(el).data('switch-image-lg');
            if (windowWidth < BREAKPOINTS.small.px) {
                if (smImgSrc) {
                    $(el).attr('src', smImgSrc);
                }
            } else {
                if (lgImgSrc) {
                    $(el).attr('src', lgImgSrc);
                }
            }
        });
    }
    switchBgImgResponsive(windowWidth) {
        $('.js-switch-bg-image-responsive').each((i, el) => {
            const smImgSrc = $(el).data('switch-bg-image-sm');
            const lgImgSrc = $(el).data('switch-bg-image-lg');
            if (windowWidth < BREAKPOINTS.small.px) {
                if (smImgSrc) {
                    $(el).css({ 'backgroundImage': `url(${smImgSrc})` });
                }
            } else {
                if (lgImgSrc) {
                    $(el).css({ 'backgroundImage': `url(${lgImgSrc})` });
                }
            }
        });
    }

    scrollOut() {
        ScrollOut({
            targets: "[data-scroll-out]",
            cssProps: false,
            // cssProps: {
            //     visibleY: true,
            //     viewportY: true
            // },
            onShown: function (el, ctx) {
                if ($(el).data('scroll-out') === 'fadeInUpSmall') {
                    $(el).addClass('animate__animated animate__fadeInUpSmall');
                }
                // console.log(ctx);
            },
            onHidden: function (el) {
                // if ($(el).data('scroll-out') === 'content') {
                //     $('[data-community-section-mask]').addClass('animate__animated animate__fadeOut animate__slow');
                // }
            },
            onChange: function (element, ctx, scrollingElement) {
                /* Triggered when an element changes visibility */
                // console.log(ctx);
            }
        });
    }

    // image modal
    // TODO: 後でちゃんとリファクタする
    // TODO: 閉じる時にチラつきがウザいためモーダルオープン中スクロール許可している
    imageModalFunction() {
        const $imageModalMask = $('.js-imageModalMask');
        const $imageModalImage = $('.js-imageModalImage');
        const $imageModalCaption = $('.js-imageModalCaption')
        let imagesLength = null;
        let currentImageIndex = null;
        // let scrollPosition = null;
        $('.js-imageModalTrigger').on('click', (e) => {
            const modalState = this.$body.attr('data-image-modal-state');
            const caption = $(e.currentTarget).attr('data-image-modal-caption');
            currentImageIndex = parseInt($(e.currentTarget).attr('data-image-modal-index'), 10);
            if (!imagesLength) {
                imagesLength = $(e.currentTarget).attr('data-image-modal-length');
            }
            let src = '';
            if (this.windowWidth < BREAKPOINTS.MEDIUM) {
                src = $(e.currentTarget).attr('data-image-modal-src-m');
            } else {
                src = $(e.currentTarget).attr('data-image-modal-src-lg');
            }
            if (!modalState || modalState == 'is-close') {
                // scrollPosition = this.$window.scrollTop();
                // this.$body.attr('data-image-modal-state', 'is-open');
                $imageModalMask.css({
                    visibility: 'visible',
                    opacity: '1'
                });
                // this.$body.css({
                //     top: -scrollPosition,
                //     height: this.windowHeight
                // });
                $imageModalImage.attr({src: src, alt:caption});
                $imageModalCaption.text(caption);
            }
        });
        $imageModalMask.on('click', () => {
            closeImageModal();
        });
        const closeImageModal = (e) => {
            $imageModalMask.css('opacity', '0'); // opcityとvisibilityは別タイミングで変更する
            $imageModalMask.on('transitionend', () => {
                // this.$body.attr('data-image-modal-state', 'is-close').removeAttr('style');
                $imageModalMask.css('visibility', 'hidden');
                // window.scrollTo(0, scrollPosition);
                $imageModalMask.off('transitionend');
            });
        };

        let touchStartX = null;
		let touchEndX = null;
        $imageModalImage.on('touchmove', (e) => {
            e.preventDefault();
			touchEndX = e.touches[0].pageX;
        });
        $imageModalImage.on('touchstart', (e) => {
            e.preventDefault();
			touchStartX = e.touches[0].pageX;
        });
        $imageModalImage.on('touchend', (e) => {
            e.preventDefault();
			if( 0 < (touchEndX - touchStartX) ) { //右に方向にスワイプ
				switchModalImage('back');
			} else { //左に方向にスワイプ
				switchModalImage('forth');
			}
        });
        $('.js-imageModalPrev').on('click', (e) => {
            this.stopPropagation(e); // maskまでイベントを伝播させない
            switchModalImage('back');
        });
        $('.js-imageModalNext').on('click', (e) => {
            this.stopPropagation(e); // maskまでイベントを伝播させない
            switchModalImage('forth');
        });
        /**
         * モーダル表示している画像を切り替える
         * @param {string} direction - 'back' or 'forth'
         */
        const switchModalImage = (direction) => {
            if (direction !== 'back' && direction !== 'forth') {
                return;
            }
            let $nextImageTrigger = null;
            if (direction === 'back') {
                if (currentImageIndex - 1 < 0) {
                    closeImageModal();
                    return;
                }
                $nextImageTrigger = $(`[data-image-modal-index="${currentImageIndex - 1}"]`);
            } else {
                if (currentImageIndex + 1 > imagesLength) {
                    closeImageModal();
                    return;
                }
                $nextImageTrigger = $(`[data-image-modal-index="${currentImageIndex + 1}"]`);
            }
            const nextCaption = $nextImageTrigger.attr('data-image-modal-caption');
            let nextImageSrc = '';
            if (this.windowWidth < BREAKPOINTS.MEDIUM) {
                nextImageSrc = $nextImageTrigger.attr('data-image-modal-src-m');
            } else {
                nextImageSrc = $nextImageTrigger.attr('data-image-modal-src-lg');
            }
            $imageModalImage.attr({src: nextImageSrc, alt:nextCaption});
            $imageModalCaption.text(nextCaption);
            currentImageIndex = direction === 'back' ? currentImageIndex - 1 : currentImageIndex + 1;
        };
    }

    // TODO: 別ファイルにする
    //記事ページ
    singlePage() {
        // YouTube埋め込みがあったときにレスポンシブにする
        if ($('.js-detect-youtube-responsive-target iframe').length) {
            $('.js-detect-youtube-responsive-target iframe').each((i, el) => {
                if ($(el).attr('src').indexOf('youtube') != -1) {
                    $(el).parent('p').addClass('c-youtube');
                }
            })
        }
    }

    setContentMinHeight() {
        const height = this.windowHeight - $('footer').outerHeight();
        $('.js-bodyContentWrapper').css('min-height', height);
    }
};
